const maskPhoneNumber = (phoneNumber: string | number): string => {
  const phoneNumberInString = typeof phoneNumber === 'number' ? String(phoneNumber) : phoneNumber
  const maskedPhone =
    phoneNumberInString !== undefined
      ? phoneNumberInString.replace(/\D/g, '').match(/(1?)(\d{0,3})(\d{0,3})(\d{0,4})/)
      : phoneNumber
  if (!maskedPhone) {
    return ''
  }

  return !maskedPhone[2]
    ? maskedPhone[1]
    : (maskedPhone[1] ? '+1' : '') +
        '(' +
        maskedPhone[2] +
        ') ' +
        maskedPhone[3] +
        (maskedPhone[4] ? '-' + maskedPhone[4] : '')
}

const removeNotNumberCharacters = (str: string): string => {
  return str.replace(/\D/g, '')
}

const priceValueMask = (value: any): string => {
  if (typeof value === 'string') {
    return '$' + parseFloat(value.replace('$', '')).toFixed(2)
  }
  return '$' + value.toFixed(2)
}

export { maskPhoneNumber, removeNotNumberCharacters, priceValueMask }



// WEBPACK FOOTER //
// ./src/utils/mask.ts